import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: false
})
export class ButtonComponent implements OnInit {
  @Input() buttonTextCase!: string;
  @Input() buttonClass!: string;
  @Input() buttonText!: string;
  @Input() buttonLink!: string;
  @Input() buttonColor!: string;
  @Input() buttonLinkActive = true;
  @Input() buttonDisabled = false;

  constructor() { }

  ngOnInit(): void {
    if (this.buttonTextCase === "lower") {
      this.buttonText = this.buttonText.toLowerCase();
    } else if (this.buttonTextCase === "upper") {
      this.buttonText = this.buttonText.toUpperCase();
    }
  }

}
